
@if(!isMobileView){
<div class="main-container">
  <div *ngFor="let view of permissionList" class="new-main-view">
    <div class="new-view-header" *ngIf="permissionList.length">
      <span>{{ view.dwh_view_label }}</span>
    </div>
    <div class="new-view-details" *ngIf="permissionList.length">
      
      <!-- @if(allowed_perm(view,list)){ -->
      <div class="subview-details d-flex flex-column">
        @for(list of view.view_permissions; track list){
        <div class="d-flex justify-content-between">
          <span class="subview-text">
            {{list.permissionLabel}}
          </span>
          <label class="switch">
            <input type="checkbox" [checked]="list.dupd_status=='Active'" (change)="handlePermissionToogle($event, list)"/>
            <span class="slider round"></span>
          </label>
        </div>
      }
      </div>
      <!-- }       -->
      
    </div>
    <!-- } -->

  </div>
</div>
}
@else {
  <!-- <div class="main-container">
    <div *ngFor="let view of views" class="new-main-view">
      <div class="new-view-header" *ngIf="view.permission.length || view.subview.length">
        <span>{{ showLabel[view.key] }}</span>
      </div>
      <div class="new-view-details" *ngIf="view.permission.length || view.subview.length">
        @for(list of view.permission; track list){ -->
        <!-- @if(allowed_perm(view,list)){ -->
        <!-- <div class="subview-details d-flex flex-column">
          <div class="d-flex justify-content-between">
            <span class="subview-text">
              {{list.name}}
            </span>
            <label class="switch">
              <input type="checkbox" [checked]="list.states.length" (change)="handlePermissionToogle($event, list)"/>
              <span class="slider round"></span>
            </label>
          </div>
  
          <div class="d-flex flex-column" style="gap: 8px"  [ngClass]="{'hidden': !isChecked}">
            @for(st of list.states; track st){
            <div class="d-flex justify-content-between">
              <span class="state-text">{{ st.state_name }}</span>
              @if(st.districts.includes('ALL') || st.districts.includes('all')){
                <span class="district-text" (click)="onDistrictClick(st)">All districts ></span>
              }
              @else {
                <span class="district-text" (click)="onDistrictClick(st)">{{ st.districts.length == 0 ? 'No':
                  st.districts.length }} districts ></span>
              } 
            </div>
            }
          </div>
          <div class="d-flex flex-column gap-3 justify-content-between">
            
          </div>
        </div> -->
        <!-- }       -->
        <!-- }
  
        @if(view.subview.length>0){
          <app-permission-viewer [views]="view.subview"
          (permissionToogleOff)="handlePermissionToogle($event, $event.rowData)"
          ></app-permission-viewer>
        }
      </div> -->
      <!-- } -->
  
    <!-- </div>
  </div> -->


  <div class="main-container">
    <div *ngFor="let view of permissionList" class="new-main-view">
      <div class="new-view-header" *ngIf="permissionList.length">
        <span>{{ view.dwh_view_label }}</span>
      </div>
      <div class="new-view-details" *ngIf="permissionList.length">
        
        <!-- @if(allowed_perm(view,list)){ -->
        <div class="subview-details d-flex flex-column">
          @for(list of view.view_permissions; track list){
          <div class="d-flex justify-content-between">
            <span class="subview-text">
              {{list.permissionLabel}}
            </span>
            <label class="switch">
              <input type="checkbox" [checked]="list.dupd_status=='Active'" (change)="handlePermissionToogle($event, list)"/>
              <span class="slider round"></span>
            </label>
          </div>
        }
        </div>
        <!-- }       -->
        
      </div>
      <!-- } -->
  
    </div>
  </div>
}